import thumbok from './imgs/thumbok.png';
import waits from './imgs/wait.gif';

import CountdownTimer from './Runtimer';

export const showmesage=(msg: any,code: any)=>{
let vsbl = 'none';
let vsblok = 'none';
let wtblok = 'none';

let vsblmain = 'block';


if(msg != 'OK' && msg != 'NA' && msg != 'WAIT'){
 vsbl = 'block';
}
else if(msg == 'OK'){
 vsblok = 'block';
}
else if(msg == 'WAIT'){
 wtblok = 'block';
}

return(
<div style={{display:vsblmain}} className="per100">

<div style={{display:vsbl}} className="per100">
			 <div>
                       	
			<a href="#" onClick={e => msgclose()} title="Close message">
			<div className="search-title-btnclose" id="togglesearch">
			  X
			</div>
			</a>
	   	     </div>
		    <div className="Sikaamsgbody">
			<div className="Sikaamsginerbody">
                        <div style={{backgroundColor:'transparent',width:'94%',textAlign:'center'}}>
			{msg} <br /> {code}
		        </div>
                        <CountdownTimer initialsec={50} />
		        </div>
			<div className="Sikaamsginerbody" style={{height:'auto',paddingRight:'20px',display:'none'}}>
			
		        </div>
		    </div>
		
		</div>
    <div className="per100">
	<div style={{display:vsblok}} className="thumbok">
		 <img src={thumbok} style={{height:'20vh',width:'20vw'}} />

   	</div>	
     

   </div>	
</div>
);
}
export const msgclose=()=>{
 const Pdivr = document.getElementById('customemsgdiv') as HTMLElement;
		Pdivr.style.display = 'none';
	
}
